<div class="meine-projekte">
  <div class="meine-projekte__kopf" #kopf>
    <h2 class="meine-projekte__titel">{{ 'home.meineProjekte.titel' | translate }}</h2>
    @if (status() === 'bereit' && projekte().length > 0) {
      <button
        type="button"
        class="meine-projekte__verwalten"
        data-testid="projekte-verwalten"
        #verwaltenKnopf
        [class.meine-projekte__verwalten--offen]="verwaltenOffen()"
        [attr.aria-expanded]="verwaltenOffen()"
        [attr.aria-controls]="verwaltenOffen() ? popoverId : null"
        (click)="verwaltenOffen.set(!verwaltenOffen())"
      >
        <mat-icon aria-hidden="true">settings</mat-icon>
        {{ 'home.meineProjekte.verwalten' | translate }}
      </button>
      @if (verwaltenOffen()) {
        <app-projekte-verwalten
          [projekte]="projekte()"
          [angeheftet]="angeheftetIds()"
          [ausgeblendet]="ausgeblendetIds()"
          (stern)="sternKlick($event)"
          (haekchen)="haekchenKlick($event)"
          (schliessen)="verwaltenSchliessen()"
        />
      }
    }
  </div>

  @switch (status()) {
    @case ('laedt') {
      <div class="meine-projekte__raster" aria-busy="true">
        <span class="sr-only">{{ 'home.meineProjekte.laedt' | translate }}</span>
        <div class="meine-projekte__skelett"></div>
        <div class="meine-projekte__skelett"></div>
      </div>
    }
    @case ('fehler') {
      <div class="meine-projekte__fehler" role="alert">
        <p class="meine-projekte__fehlertext">{{ 'home.meineProjekte.fehler' | translate }}</p>
        <button type="button" class="meine-projekte__erneut" (click)="laden()">
          {{ 'home.meineProjekte.erneut' | translate }}
        </button>
      </div>
    }
    @default {
      @if (projekte().length === 0) {
        <div class="meine-projekte__leer">{{ 'home.meineProjekte.keinProjekt' | translate }}</div>
      } @else if (sichtbare().length === 0) {
        <div class="meine-projekte__leer">{{ 'home.meineProjekte.alleAusgeblendet' | translate }}</div>
      } @else {
        <div class="meine-projekte__raster">
          @for (projekt of sichtbare(); track projekt.projectId) {
            @let istAngeheftet = angeheftet(projekt.projectId);
            @let lauf = laufText(projekt);
            <div class="projekt-karte" [class.projekt-karte--angeheftet]="istAngeheftet">
              <div
                class="projekt-karte__link"
                role="link"
                tabindex="0"
                data-testid="projekt-karte"
                (click)="oeffnen(projekt.projectId)"
                (keydown.enter)="oeffnen(projekt.projectId)"
              >
                <div class="projekt-karte__kopf">
                  <span
                    class="projekt-karte__kuerzel"
                    [style.background]="farbe(projekt)"
                    [style.color]="schrift(projekt)"
                  >
                    {{ projekt.kuerzel }}
                  </span>
                  <div class="projekt-karte__text">
                    <div class="projekt-karte__namenszeile">
                      <span class="projekt-karte__name">{{ projekt.name }}</span>
                      @if (istAngeheftet) {
                        <span class="projekt-karte__badge">{{ 'home.meineProjekte.badge' | translate }}</span>
                      }
                    </div>
                    <div
                      class="projekt-karte__lauf"
                      [class.projekt-karte__lauf--fehlgeschlagen]="projekt.letzterLauf?.status === 'FEHLGESCHLAGEN'"
                    >
                      @if (projekt.letzterLauf?.status === 'LAEUFT') {
                        <span class="projekt-karte__puls" aria-hidden="true"></span>
                      }
                      {{ lauf.key | translate: lauf.params }}
                    </div>
                  </div>
                </div>
                <div class="projekt-karte__rate">
                  <div class="projekt-karte__spur">
                    <div
                      [class]="'projekt-karte__fuellung projekt-karte__fuellung--' + balkenStufe(projekt.passRate)"
                      [style.width.%]="projekt.passRate ?? 0"
                    ></div>
                  </div>
                  <span class="projekt-karte__zahl">
                    {{
                      projekt.passRate === null ? ('home.meineProjekte.keineRate' | translate) : projekt.passRate + '%'
                    }}
                  </span>
                </div>
              </div>
              <button
                type="button"
                class="projekt-karte__stern"
                data-testid="projekt-stern"
                [attr.aria-pressed]="istAngeheftet"
                [attr.aria-label]="
                  (istAngeheftet ? 'home.meineProjekte.nichtMehrAnheften' : 'home.meineProjekte.anheften') | translate
                "
                [title]="(istAngeheftet ? 'home.meineProjekte.angeheftet' : 'home.meineProjekte.anheften') | translate"
                (click)="sternKlick(projekt.projectId)"
              >
                {{ istAngeheftet ? '★' : '☆' }}
              </button>
            </div>
          }
        </div>
      }
    }
  }
</div>
